import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const faqItems = [
  { qKey: 'faqQ1', aKey: 'faqA1' },
  { qKey: 'faqQ2', aKey: 'faqA2' },
  { qKey: 'faqQ3', aKey: 'faqA3' },
  { qKey: 'faqQ4', aKey: 'faqA4' },
  { qKey: 'faqQ5', aKey: 'faqA5' },
];

export default function FAQSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full py-14 md:py-20 bg-background-50" id="faq">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-8 md:mb-10 text-center">
          {t('faqTitle')}
        </h2>
        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="border border-background-200 rounded-lg bg-white overflow-hidden"
            >
              <button
                onClick={() => toggle(index)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-6">
                  {t(item.qKey)}
                </h3>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center text-foreground-400">
                  <i className={`text-base ${openIndex === index ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </span>
              </button>
              <div
                className={`px-5 overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'pb-5 max-h-96' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {t(item.aKey)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}